import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { CustomerService } from 'src/app/angularJS/services/customer/customer.service';

/**
* A controller which is used to add annonymous card
*/
export class SmartMediaAddCardController {
  public static $inject = [
    '$state',
    '$rootScope',
    'customerService',
    'customer',
    'UserMessages',
    '$translate'
  ];
  public steps: Array<InterACT.Interfaces.ISteps>;
  public isValidCardNumber: boolean;
  public errorMessage: string;
  public inactiveCards: Array<InterACT.Interfaces.Cards.Card>;
  public card: InterACT.Interfaces.Cards.Card;
  public customerLink: InterACT.Interfaces.ChargeAccounts.CustomerLink;
  public name: string;
  public currentLocale: string;
  public stepForward: Function;
  public stepBackward: Function;

  constructor(
    private $state: angular.ui.IStateService,
    private $rootScope,
    private customerService: CustomerService,
    private customer: InterACT.Interfaces.Customers.Customer,
    private UserMessages: UserMessagesService,
    private $translate: ng.translate.ITranslateService
  ) {
    this.customer = angular.copy(customer);
    this.currentLocale = $translate.use();
    this.isValidCardNumber = false;
    this.inactiveCards = [];
    this.card = <any>{};
    this.customerLink = <any>{};
    this.name = this.customer.title + ' ' + this.customer.forename + ' ' + this.customer.surname;
    this.steps = this.setupSteps();
    this.activate();
  }

  /**
    * A method which is used to get the card deatils and redirect to next step
    * @param index The step index that should be moved to after determining a card exists and not yet been registered
    */
  public getCard(index: number) {
    this.$rootScope.showSpinner = true;
    const param = 'cardNumber.SERIAL_NUMBER=' + this.card.cardNumber + ' or cardNumber.ISRN=' + this.card.cardNumber;
    this.customerService.getCards(param).then((inactiveCards: Array<InterACT.Interfaces.Cards.Card>) => {
      this.inactiveCards = inactiveCards;
      if (inactiveCards.length > 0) {
        if (angular.isDefined(this.inactiveCards[0].customer)) {
          this.errorMessage = this.$translate.instant('CUSTOMER_DETAIL.ALREADY_REGISTERED');
          this.isValidCardNumber = true;
          this.$rootScope.showSpinner = false;
          return;
        }
        this.errorMessage = '';
        this.customerLink.name = this.name;
        this.customerLink.link = '/customers/' + this.customer.id;
        this.inactiveCards[0].customer = this.customerLink;
        this.stepForward(index);
      } else {
        this.errorMessage = this.$translate.instant('CUSTOMER_DETAIL.CARD_NOT_EXIST');
        this.isValidCardNumber = true;
        return;
      }
    });
    this.$rootScope.showSpinner = false;
  }

  /**
   * A method which is used to set steppers
   */
  private setupSteps() {
    return [
      { id: 1, desc: this.$translate.instant('CUSTOMER_DETAIL.ADD_CARD_STEP1'), title: this.$translate.instant('CUSTOMER_DETAIL.ADD_CARD_STEP1_TITLE') },
      { id: 2, desc: this.$translate.instant('CUSTOMER_DETAIL.ADD_CARD_STEP2'), title: this.$translate.instant('CUSTOMER_DETAIL.ADD_CARD_STEP2_TITLE1') + this.name + this.$translate.instant('CUSTOMER_DETAIL.ADD_CARD_STEP2_TITLE2') }
    ];
  }

  /**
   * A method which is used to instantiate the controller
   */
  private activate() {
    this.isValidCardNumber = false;
  }

  /**
  * A method which is used to register annoymous card
  */
  private registerCard = () => {
    this.customerService.updateCard(this.inactiveCards[0].id, this.inactiveCards[0])
      .then((value) => {
        this.UserMessages.showToast('TOAST_MESSAGE.CARD.SUCCESS');
        this.exitAddCard();
      }).catch(() => {
        this.UserMessages.showToast('TOAST_MESSAGE.CARD.ERROR');
      });
  }

  /**
   * A method which is used to go back to smart media
   */
  private exitAddCard = () => {
    this.$state.go('customer.smartmedia.list');
  }

  /**
   * A method which is used to showDialog and go back to smart media
   */
  private showConfirmDialog = () => {
    return this.UserMessages.buildConfirmDialog(
      'CONFIRM_DIALOG.CUSTOMER.TITLE',
      'CONFIRM_DIALOG.CUSTOMER.MESSAGE',
      {},
      'CONFIRM_DIALOG.CUSTOMER.CONFIRM',
      'CONFIRM_DIALOG.CUSTOMER.NO')
      .then(() => {
        this.exitAddCard();
      });
  }
}
